export enum CALL_RECORD_DASHBOARD_BLOCK_TYPES {
    CLIENTS = 'clients',
    EMPLOYEES = 'employees',
    ALL_CALLS = 'allCalls',
    CANCELED_CALLS = 'cancelledCalls',
    CLOSED_CALLS = 'closedCalls'
}
